export const CONFIG = {
  urls: {
    HOME: '/',
    SIGN_IN: '/sign-in',
  },
};
